<style scoped>
.v-application .subtitle-1 {
  font-size: 14px !important;
  font-weight: normal;
  letter-spacing: 0.009375em !important;
  line-height: 1.75rem;
  font-family: "Prompt", sans-serif !important;
}
</style>

<template>
  <div>
    <v-file-input
      dense
      multiple
      chips
      outlined
      type="file"
      @change="onSelect"
      prepend-inner-icon="mdi-file-upload"
      prepend-icon
    ></v-file-input>

    <!-- <v-col col="12" lg="3">
        <v-btn @click="onUpload()">upload</v-btn>
      </v-col> -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "DocFileUpload",
  props: {},
  data: () => ({
    message: "",
    file: "",
  }),
  watch: {},
  methods: {
    onSelect(file) {
      // console.log("%c onSelect file", "color:Navy  ");
      //console.log(file);
      const allowedTypes = [
        "application/pdf",
        // "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        // "application/msword",
      ];
      //const file = this.$refs.file.files[0];
      this.file = file;
      for (var i = 0; i < file.length; i++) {
        if (!allowedTypes.includes(file[i].type)) {
          this.$swal(
            "ประเภทข้อมูลไม่ถูกต้อง",
            "กรุณาเลือกประเภท .pdf ",
            "error"
          );
          this.file = "";
          this.$emit("click:clear");
          console.log(this.file);
        }
      }

      //   if(file.size>500000){
      //     this.message = 'Too large, max size allowed is 500kb'
      //   }
    },
    async onUpload(cus_id) {
      const formData = new FormData();

      let files = this.file;
      console.log(files);

      if (files) {
        let fileData;
        for (var i = 0; i < files.length; i++) {
          fileData = files[i];
          formData.set("cus_id", cus_id);
          formData.append("files", fileData);
        }
        if (i == files.length) {
          console.log("passss");
          let finish = await this.$guest_api
            .post("/upload-customer-document-file", formData)
            .catch((e) => {
              this.$swal(
                "เกิดข้อผิดพลาดในการอัพโหลด",
                "กรุณาลองใหม่อีกครั้ง",
                "error"
              );
            });
          return finish;
        }
      } else {
        console.log("not document file");
        return;
      }

      /*
      if (files) {

        for (var i = 0; i < files.length; i++) {
          let fileData = files[i];
          formData.append("files", fileData);
        }
        formData.append("cus_id", cus_id);
        
        console.log("%c onUpload formData", "color:LimeGreen");
        console.log(formData);
        let finish = await this.$guest_api
          .post("/upload-customer-document-file", formData)
          .catch((e) => {
            this.$swal(
              "เกิดข้อผิดพลาดในการอัพโหลด",
              "กรุณาลองใหม่อีกครั้ง",
              "error"
            );
          });

        return finish;
      } else {
        this.$swal("ประเภทข้อมูลไม่ถูกต้อง", "กรุณาลองใหม่อีกครั้ง", "error");
        return;
      }
      */
    },
  },
};
</script>

